import { AuthConfig } from 'angular-oauth2-oidc';
import { environment } from '../../../environments/environment';

export const authConfig: AuthConfig = {
  issuer: environment.issuer,
  clientId: environment.clientId,
  responseType: 'code',
  redirectUri: globalThis.location.origin,
  silentRefreshRedirectUri: `${globalThis.location.origin}/silent-refresh.html`,
  scope: 'openid profile groups',
  useSilentRefresh: true,
  silentRefreshTimeout: 840000,
  timeoutFactor: 0.75, 
  sessionChecksEnabled: false,
  showDebugInformation: false,
  tokenEndpoint: environment.tokenEndpoint,
  loginUrl: environment.loginUrl,
  userinfoEndpoint: environment.userinfoEndpoint,
};
